export default {
  triggers: 'mdi-lightning-bolt-outline',
  ai: 'mdi-shimmer',
  filter: 'mdi-filter-variant'
}
